import { useEffect } from "react";
import { useContentObject } from "../hooks/useContentData";
import { contentFallback } from "../contentDefaults";

function setMeta(name, content, attr = "name") {
  if (!content) return;
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

/** Título de pestaña y meta SEO desde CMS (site.seo) */
export default function SiteHead() {
  const { data: seo } = useContentObject("site.seo", contentFallback("site.seo"));

  useEffect(() => {
    const pageTitle = seo?.page_title;
    const ogTitle = seo?.og_title || pageTitle;
    const ogDesc = seo?.og_description || seo?.meta_description;
    const ogImage = seo?.og_image;

    if (pageTitle) {
      document.title = pageTitle;
    }
    setMeta("description", seo?.meta_description);
    setMeta("og:title", ogTitle, "property");
    setMeta("og:description", ogDesc, "property");
    setMeta("og:url", window.location.href, "property");
    if (ogImage) {
      const absImage = ogImage.startsWith("http") ? ogImage : `${window.location.origin}${ogImage.startsWith("/") ? "" : "/"}${ogImage}`;
      setMeta("og:image", absImage, "property");
      setMeta("twitter:image", absImage);
    }
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", ogTitle);
    setMeta("twitter:description", ogDesc);
  }, [seo]);

  return null;
}
